import { createApiSlice } from "@common";
import {
  CRUD_INTEGRATION_SERVICE,
  GET_SERVICE_MASTER_BY_INTEGRATION
} from "@routes";

// Define the API config array
const apiConfig = [
  {
    name: "addIntegrationService",
    method: "post",
    url: CRUD_INTEGRATION_SERVICE,
    stateKey: "message",
  },
  {
    name: "getServiceMasterByIntegration",
    method: "get",
    url: GET_SERVICE_MASTER_BY_INTEGRATION,
    stateKey: "data",
  },
  {
    name: "updateIntegrationService",
    method: "put",
    url: CRUD_INTEGRATION_SERVICE,
    stateKey: "message",
  },
  {
    name: "deleteIntegrationService",
    method: "delete",
    url: CRUD_INTEGRATION_SERVICE,
    stateKey: "message",
  },
];

// Define custom reducers and their initial state
const customReducers = {
  initialState: {
    additionalData: [],
  },
  reducers: {
    setAdditionalData: (state, action) => {
      state.additionalData = action.payload;
    },
  },
  extraReducers: {
    // Example of custom extra reducer
    someCustomAction: (state, action) => {
      // Custom reducer logic
    },
  },
};

// Generate the slice, thunks, and actions using the utility function
const { slice, thunks, actions } = createApiSlice(
  "integrationService",
  apiConfig,
  customReducers,
);
const integrationServiceSlice = slice;
// Export the slice's reducer
export default integrationServiceSlice.reducer;

// Destructure and export thunks directly from thunksExports
export const {
  addIntegrationService,
  getServiceMasterByIntegration,
  updateIntegrationService,
  deleteIntegrationService,
} = thunks;

// Destructure and export actions directly from actionsExports
export const { rowSelect, } =
  actions;
